// Skip-to-main-content link. Hidden until focused (via keyboard
// navigation), so screen readers and keyboard users can jump past
// the rail + top bar straight to the active view. Renders as the
// first focusable element inside <body> so it works regardless of
// where focus is when the user starts tabbing.

export function SkipLink({ targetId = "app-main" }: { targetId?: string }) {
  return (
    <a
      href={`#${targetId}`}
      className="sr-only focus:not-sr-only focus:absolute focus:left-3 focus:top-3 focus:z-50 focus:rounded-full focus:bg-primary focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-primary-foreground focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary/40"
    >
      跳到主要內容
    </a>
  );
}
